export default "__VITE_ASSET__BhQkLjRU__"